import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import { AngleDownIcon } from '@wf-sl/common-icons'
import T3Constants from '../constants'
import Select from './select'

import styles from './icon-select.module.css'

const propTypes = {
    disabled: PropTypes.bool,
    error: PropTypes.instanceOf(Error),
    headerClassName: PropTypes.string,
    icon: PropTypes.node.isRequired
}

const defaultProps = {
    disabled: false
}

function IconSelect({ children, icon, ...props }) {
    const { disabled, error, headerClassName } = props
    const iconSelectHeader = <IconSelectHeader {...{ disabled, error, headerClassName, icon }} />
    return (
        <Select header={iconSelectHeader} {...props}>
            {children}
        </Select>
    )
}

IconSelect.propTypes = propTypes
IconSelect.defaultProps = defaultProps

const iconSelectHeaderPropTypes = {
    disabled: PropTypes.bool,
    dropdownOpen: PropTypes.bool,
    error: PropTypes.instanceOf(Error),
    headerClassName: PropTypes.string,
    icon: PropTypes.node,
    onClick: PropTypes.func,
    options: PropTypes.arrayOf(PropTypes.node),
    selectedOptions: PropTypes.arrayOf(PropTypes.node)
}

const iconSelectDefaultProps = {
    disabled: false,
    onClick() {}
}

function IconSelectHeader(props) {
    const { disabled, dropdownOpen, error, headerClassName, icon, onClick, options, selectedOptions } = props
    const classNameMerged = cx(styles['icon-select-header'], 't3sel-icon-select-header', {
        't3sel-icon-select-header-disabled': disabled,
        [styles['disabled']]: disabled,
        [styles['error']]: error instanceof Error,
        [styles['open']]: dropdownOpen
    })

    const option = selectedOptions.shift() || options.shift()
    const affix = option.props.affix ? (
        <div className={styles['affix']}>{` ${T3Constants.HtmlEntities.NDASH} ${option.props.affix}`}</div>
    ) : (
        ''
    )

    return (
        <div className={classNameMerged} onClick={onClick}>
            {icon && <div className={styles['icon-select-header-icon']}>{icon}</div>}
            <span className={cx(styles['icon-select-header-content'], headerClassName)}>
                {option.props.children}
                {affix}
            </span>
            <AngleDownIcon className={styles['icon-select-header-button']} />
        </div>
    )
}

IconSelectHeader.propTypes = iconSelectHeaderPropTypes
IconSelectHeader.defaultProps = iconSelectDefaultProps

export default IconSelect
